(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["agotados-al-final"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('agotados-al-final')) return;

    class AgotadosAlFinal extends HTMLElement {
      connectedCallback() {
        this.boton = this.querySelector('.agotados-al-final__boton');
        this.lista = this.querySelector('.agotados-al-final__lista');
        this.titulo = this.querySelector('.agotados-al-final__titulo');
        // Todo el aviso abre la lista, no solo el botón
        this.querySelector('.agotados-al-final__aviso').addEventListener('click', this.mostrar.bind(this));
        this.preparar();
      }

      // Trae las tarjetas del filtro «Agotado» y deja solo los productos sin stock en ningún
      // color: los que tienen algún color disponible ya están en la lista de arriba.
      preparar() {
        var self = this;
        var paginas = Math.max(1, parseInt(this.dataset.paginas, 10) || 1);
        var pedidos = [];
        for (var i = 1; i <= paginas; i++) {
          pedidos.push(
            fetch(this.dataset.url + '&page=' + i)
              .then(function (r) {
                if (!r.ok) throw new Error(r.status);
                return r.text();
              })
              .then(function (html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var grilla = doc.querySelector('ul#product-grid');
                if (grilla && !self.claseGrilla) self.claseGrilla = grilla.className;
                return Array.prototype.filter
                  .call(doc.querySelectorAll('#product-grid > li.grid__item'), function (li) {
                    return li.querySelector('.badge--sold-out:not(.badge--sin-stock-color)');
                  })
                  .map(function (li) { return li.outerHTML; });
              })
          );
        }
        Promise.all(pedidos)
          .then(function (grupos) {
            self.tarjetas = [].concat.apply([], grupos);
            if (!self.tarjetas.length || !self.isConnected) return;
            self.querySelectorAll('[data-plantilla]').forEach(function (el) {
              el.textContent = el.dataset.plantilla.replace('__N__', self.tarjetas.length);
            });
            self.ponerFotos();
            self.hidden = false;
          })
          .catch(function (e) {
            console.error('Preventa y sin stock:', e);
          });
      }

      // Hasta tres fotos de los productos ocultos, tomadas de sus tarjetas
      ponerFotos() {
        var fotos = this.querySelector('.agotados-al-final__fotos');
        var mas = this.querySelector('.agotados-al-final__mas');
        var puestas = 0;
        for (var i = 0; i < this.tarjetas.length && puestas < 3; i++) {
          var img = new DOMParser().parseFromString(this.tarjetas[i], 'text/html').querySelector('img');
          if (!img) continue;
          var src = img.getAttribute('src') || (img.getAttribute('srcset') || '').split(' ')[0];
          if (!src) continue;
          var foto = document.createElement('img');
          foto.src = src;
          foto.alt = '';
          foto.loading = 'lazy';
          foto.width = 64;
          foto.height = 64;
          fotos.insertBefore(foto, mas);
          puestas++;
        }
        // Con 3 o menos productos y todas sus fotos a la vista, el «+N» sobra
        if (puestas && puestas >= this.tarjetas.length) mas.hidden = true;
        else if (puestas) mas.textContent = '+' + (this.tarjetas.length - puestas);
      }

      mostrar() {
        if (!this.tarjetas || this.lista.childElementCount) return;
        this.lista.className = (this.claseGrilla || 'grid product-grid') + ' agotados-al-final__lista';
        this.lista.innerHTML = this.tarjetas.join('');
        // Las animaciones de aparición del tema dejan las tarjetas invisibles si no se disparan
        this.lista.querySelectorAll('.scroll-trigger, [data-cascade], .appear-animate-item-in-list').forEach(function (el) {
          el.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in', 'appear-animate-item-in-list');
        });
        this.lista.hidden = false;
        this.titulo.hidden = false;
        this.querySelector('.agotados-al-final__aviso').hidden = true;
        this.titulo.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    customElements.define('agotados-al-final', AgotadosAlFinal);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blog-discovery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blog-discovery')) {
    customElements.define('blog-discovery', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.root = this.closest('.shopify-section');
        this.grid = this.root.querySelector('[data-blog-grid]');
        if (!this.grid) return;
        this.ready = true;
        this.input = this.querySelector('input[type="search"]');
        this.feedback = this.querySelector('.blog-discovery__feedback');
        this.status = this.querySelector('[role="status"]');
        this.pagination = this.root.querySelector('[data-blog-pagination]');
        this.original = [...this.grid.children];
        this.version = 0;
        this.year = this.querySelector('[data-date-part="year"]');
        this.month = this.querySelector('[data-date-part="month"]');
        this.day = this.querySelector('[data-date-part="day"]');
        this.clearButton = this.querySelector('.blog-discovery__clear');
        this.querySelector('.blog-discovery__dates').hidden = false;
        this.panel = this.querySelector('.blog-discovery__panel');
        this.desktop = matchMedia('(min-width: 990px)');
        this.resizePanel = () => { this.panel.open = this.desktop.matches; };
        this.resizePanel();
        this.desktop.addEventListener('change', this.resizePanel);
        this.querySelector('.blog-discovery__toggle').addEventListener('click', event => {
          if (this.desktop.matches) event.preventDefault();
        });
        const params = new URL(location.href).searchParams;
        this.dateState = {
          year: /^\d{4}$/.test(params.get('blog_year') || '') ? params.get('blog_year') : '',
          month: /^(0[1-9]|1[0-2])$/.test(params.get('blog_month') || '') ? params.get('blog_month') : '',
          day: /^(0[1-9]|[12]\d|3[01])$/.test(params.get('blog_day') || '') ? params.get('blog_day') : ''
        };
        if (!this.dateState.year) this.dateState.month = '';
        if (!this.dateState.month) this.dateState.day = '';
        [this.year, this.month, this.day].forEach(select => {
          select.addEventListener('change', () => {
            clearTimeout(this.timer);
            const part = select.dataset.datePart;
            this.dateState[part] = select.value;
            if (part === 'year') this.dateState.month = '';
            if (part !== 'day') this.dateState.day = '';
            this.updateDateOptions();
            this.search();
          });
        });
        const selector = this.querySelector('.blog-discovery__selector');
        if (selector) {
          this.addEventListener('keydown', event => {
            if (event.key === 'Escape' && selector.open) {
              selector.open = false;
              selector.querySelector('summary').focus();
            }
          });
          this.addEventListener('click', event => {
            if (!selector.contains(event.target)) selector.open = false;
          });
          selector.addEventListener('focusout', event => {
            if (!selector.contains(event.relatedTarget)) selector.open = false;
          });
        }
        this.querySelector('form').addEventListener('submit', event => {
          event.preventDefault();
          clearTimeout(this.timer);
          this.search();
        });
        this.input.addEventListener('input', () => {
          clearTimeout(this.timer);
          this.version++;
          this.timer = setTimeout(() => this.search(), 300);
        });
        this.querySelector('.blog-discovery__clear').addEventListener('click', () => {
          clearTimeout(this.timer);
          this.input.value = '';
          this.dateState = { year: '', month: '', day: '' };
          this.updateDateOptions();
          this.search();
          this.input.focus();
        });
        this.input.value = new URL(location.href).searchParams.get('blog_q') || '';
        this.search();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.desktop?.removeEventListener('change', this.resizePanel);
      }

      updateDateOptions() {
        const fill = (select, entries, value) => {
          select.replaceChildren(select.options[0], ...entries.map(([key, label]) => new Option(label, key)));
          select.value = value;
        };
        const years = new Set((this.articles || []).map(card => card.dataset.date?.slice(0, 4)).filter(Boolean));
        if (this.dateState.year) years.add(this.dateState.year);
        fill(this.year, [...years].sort().reverse().map(year => [year, year]), this.dateState.year);
        const months = Array.from({ length: 12 }, (_, index) => [
          String(index + 1).padStart(2, '0'),
          new Intl.DateTimeFormat(document.documentElement.lang || 'es', { month: 'long', timeZone: 'UTC' }).format(new Date(Date.UTC(2000, index, 1)))
        ]);
        fill(this.month, months, this.dateState.month);
        const days = this.dateState.month ? new Date(Number(this.dateState.year), Number(this.dateState.month), 0).getDate() : 0;
        if (Number(this.dateState.day) > days) this.dateState.day = '';
        fill(this.day, Array.from({ length: days }, (_, index) => [String(index + 1).padStart(2, '0'), String(index + 1)]), this.dateState.day);
        this.year.disabled = !this.articles;
        this.month.disabled = !this.articles || !this.dateState.year;
        this.day.disabled = !this.articles || !this.dateState.month;
      }

      normalize(value) {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
      }

      async loadArticles() {
        if (this.articles) return this.articles;
        if (this.pending) return this.pending;
        this.pending = (async () => {
          const pages = Number(this.grid.dataset.pages);
          const current = Number(this.grid.dataset.page);
          const batches = new Map([[current, this.original]]);
          const queue = Array.from({ length: pages }, (_, index) => index + 1).filter(page => page !== current);
          await Promise.all(Array.from({ length: Math.min(3, queue.length) }, async () => {
            while (queue.length) {
              const page = queue.shift();
              const url = new URL(location.href);
              url.searchParams.delete('blog_q');
              ['year', 'month', 'day'].forEach(part => url.searchParams.delete('blog_' + part));
              url.searchParams.set('page', page);
              url.searchParams.set('section_id', this.dataset.section);
              const response = await fetch(url, { signal: AbortSignal.timeout(20000) });
              if (!response.ok) throw new Error('Blog request failed');
              const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
              const grid = doc.querySelector('[data-blog-grid]');
              if (!grid) throw new Error('Missing blog grid');
              batches.set(page, [...grid.children]);
            }
          }));
          this.articles = [...batches.entries()].sort((a, b) => a[0] - b[0]).flatMap(([, cards]) => cards);
          return this.articles;
        })().finally(() => { this.pending = null; });
        return this.pending;
      }

      async search() {
        const version = ++this.version;
        const query = this.input.value.trim();
        const url = new URL(location.href);
        const filtered = Boolean(query || this.dateState.year);
        if (query) url.searchParams.set('blog_q', query);
        else url.searchParams.delete('blog_q');
        Object.entries(this.dateState).forEach(([part, value]) => {
          if (value) url.searchParams.set('blog_' + part, value);
          else url.searchParams.delete('blog_' + part);
        });
        history.replaceState(history.state, '', url);
        this.querySelectorAll('.blog-discovery__links a').forEach(link => {
          const target = new URL(link.href);
          if (query) target.searchParams.set('blog_q', query);
          else target.searchParams.delete('blog_q');
          Object.entries(this.dateState).forEach(([part, value]) => {
            if (value) target.searchParams.set('blog_' + part, value);
            else target.searchParams.delete('blog_' + part);
          });
          link.href = target.href;
        });
        this.clearButton.hidden = !filtered;
        this.feedback.hidden = false;
        this.status.textContent = this.dataset.loading;
        this.grid.setAttribute('aria-busy', 'true');
        try {
          const articles = await this.loadArticles();
          if (version !== this.version || !this.isConnected) return;
          this.updateDateOptions();
          if (!filtered) {
            this.grid.replaceChildren(...this.original);
            if (this.pagination) this.pagination.hidden = false;
            this.feedback.hidden = true;
            return;
          }
          const words = this.normalize(query).split(/\s+/);
          const datePrefix = [this.dateState.year, this.dateState.month, this.dateState.day].filter(Boolean).join('-');
          const matches = articles.filter(card => {
            const text = this.normalize(card.dataset.search || '');
            return words.every(word => text.includes(word)) && (card.dataset.date || '').startsWith(datePrefix);
          });
          this.grid.replaceChildren(...matches.map(card => card.cloneNode(true)));
          if (this.pagination) this.pagination.hidden = true;
          this.status.textContent = matches.length ? this.dataset.results.replace('[count]', matches.length) : this.dataset.empty;
        } catch {
          if (version !== this.version) return;
          this.grid.replaceChildren(...this.original);
          if (this.pagination) this.pagination.hidden = false;
          this.status.textContent = this.dataset.error;
        } finally {
          if (version === this.version) this.grid.removeAttribute('aria-busy');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["buscador-coleccion"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('buscador-coleccion')) return;

    // Sobrevive a que facets.js reescriba la grilla al cambiar un filtro
    var estado = { termino: '' };
    var cache = {};

    function normalizar(s) {
      return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    }

    function urlFuente() {
      var params = new URLSearchParams(location.search);
      params.delete('page');
      params.set('sections', 'buscador-coleccion');
      return location.pathname + '?' + params.toString();
    }

    function cargar() {
      var url = urlFuente();
      if (!cache[url]) {
        cache[url] = fetch(url)
          .then(function (r) {
            if (!r.ok) throw new Error(r.status);
            return r.json();
          })
          .then(function (json) {
            var doc = new DOMParser().parseFromString(json['buscador-coleccion'] || '', 'text/html');
            return Array.prototype.map.call(doc.querySelectorAll('li[data-buscar]'), function (li) {
              return { texto: normalizar(li.dataset.buscar), html: li.outerHTML };
            });
          })
          .catch(function (e) {
            delete cache[url];
            throw e;
          });
      }
      return cache[url];
    }

    class BuscadorColeccion extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input');
        this.borrar = this.querySelector('.buscador-coleccion__borrar');
        this.estadoEl = this.querySelector('.buscador-coleccion__estado');
        this.contenedor = this.closest('#ProductGridContainer') || document;

        this.input.addEventListener('input', () => {
          clearTimeout(this.espera);
          this.espera = setTimeout(() => this.buscar(this.input.value), 220);
        });
        this.input.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') e.preventDefault();
          if (e.key === 'Escape') this.limpiar();
        });
        this.borrar.addEventListener('click', () => {
          this.limpiar();
          this.input.focus();
        });
        // Sombra solo cuando la barra está pegada arriba
        this.alDesplazar = () => {
          var tope = parseFloat(getComputedStyle(this).top) || 0;
          this.classList.toggle('is-fija', window.scrollY > 0 && this.getBoundingClientRect().top <= tope + 1);
        };
        window.addEventListener('scroll', this.alDesplazar, { passive: true });
        this.alDesplazar();

        // Precarga al primer foco para que el primer resultado salga al instante
        this.input.addEventListener('focus', () => cargar().catch(function () {}), { once: true });

        if (estado.termino) {
          this.input.value = estado.termino;
          this.buscar(estado.termino);
        } else if (this.contenedor.removeAttribute) {
          this.contenedor.removeAttribute('data-buscando');
        }
      }

      disconnectedCallback() {
        // facets.js reemplazó la grilla: invalida cualquier carga pendiente de esta instancia
        this.turno = (this.turno || 0) + 1;
        clearTimeout(this.espera);
        window.removeEventListener('scroll', this.alDesplazar);
      }

      limpiar() {
        this.input.value = '';
        this.buscar('');
      }

      texto(clave, n, t) {
        return this.dataset[clave].replace('__N__', n).replace('__T__', t);
      }

      buscar(valor) {
        var termino = valor.trim();
        estado.termino = termino;
        this.borrar.hidden = !termino;
        var palabras = normalizar(termino).split(/\s+/).filter(function (p) { return p.length; });
        var turno = (this.turno = (this.turno || 0) + 1);

        if (!palabras.length) {
          this.contenedor.removeAttribute && this.contenedor.removeAttribute('data-buscando');
          if (this.lista) this.lista.remove();
          this.lista = null;
          this.estadoEl.textContent = '';
          return;
        }

        if (!cache[urlFuente()]) this.estadoEl.textContent = this.dataset.cargando;
        cargar()
          .then((items) => {
            if (turno !== this.turno || !this.isConnected) return;
            var hallados = items.filter(function (it) {
              return palabras.every(function (p) { return it.texto.indexOf(p) !== -1; });
            });
            this.mostrar(hallados, termino);
          })
          .catch(() => {
            if (turno === this.turno && this.isConnected) this.estadoEl.textContent = this.dataset.error;
          });
      }

      mostrar(hallados, termino) {
        var grilla = this.contenedor.querySelector('#product-grid');
        if (!this.lista) {
          this.lista = document.createElement('ul');
          this.lista.className = (grilla && grilla.tagName === 'UL' ? grilla.className : 'grid product-grid') + ' buscador-coleccion__resultados';
          this.lista.setAttribute('role', 'list');
          if (grilla && grilla.tagName === 'UL') grilla.after(this.lista);
          else this.after(this.lista);
        }
        this.contenedor.setAttribute('data-buscando', '');
        this.lista.innerHTML = hallados.map(function (it) { return it.html; }).join('');
        // Las animaciones de aparición del theme dejan las tarjetas invisibles si no se disparan
        this.lista.querySelectorAll('.scroll-trigger, [data-cascade]').forEach(function (el) {
          el.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in');
        });

        if (!hallados.length) this.estadoEl.textContent = this.texto('vacio', 0, termino);
        else if (hallados.length === 1) this.estadoEl.textContent = this.texto('uno', 1, termino);
        else this.estadoEl.textContent = this.texto('varios', hallados.length, termino);
      }
    }

    customElements.define('buscador-coleccion', BuscadorColeccion);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["consentimiento-datos"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__consentimientoListo) return;
    window.__consentimientoListo = true;

    const esCasilla = (el) =>
      el && el.dataset && el.dataset.mensajeConsentimiento !== undefined;

    // 'invalid' no burbujea: hay que escucharlo en la fase de captura.
    document.addEventListener(
      'invalid',
      (evento) => {
        const el = evento.target;
        if (!esCasilla(el)) return;
        el.setCustomValidity(el.dataset.mensajeConsentimiento);
        el.classList.add('consentimiento__casilla--falta');
      },
      true
    );

    document.addEventListener('change', (evento) => {
      const el = evento.target;
      if (!esCasilla(el)) return;
      el.setCustomValidity('');
      el.classList.remove('consentimiento__casilla--falta');
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cupon-carro"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cupon-carro')) {
    class CuponCarro extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[name="codigo"]');
        this.mensaje = this.querySelector('.cupon-carro__mensaje');
        this.lista = this.querySelector('.cupon-carro__codigos');
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.aplicar();
        });
        this.lista.addEventListener('click', (e) => {
          const boton = e.target.closest('.cupon-carro__quitar');
          if (boton) this.quitar(boton.closest('[data-codigo]').dataset.codigo);
        });
      }

      actuales() {
        return [...this.lista.querySelectorAll('[data-codigo]')].map((li) => li.dataset.codigo);
      }

      avisar(texto, tipo) {
        this.mensaje.textContent = texto;
        this.mensaje.className = 'cupon-carro__mensaje' + (tipo ? ' cupon-carro__mensaje--' + tipo : '');
      }

      async enviar(codigos) {
        const respuesta = await fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/update.js' : '/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            discount: codigos.join(','),
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        });
        if (!respuesta.ok) throw new Error('HTTP ' + respuesta.status);
        return respuesta.json();
      }

      redibujar(carro) {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && carro.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents({ id: null, sections: carro.sections });
        }
        const aplicados = (carro.discount_codes || []).filter((d) => d.applicable);
        this.lista.innerHTML = '';
        aplicados.forEach((d) => {
          const li = document.createElement('li');
          li.className = 'cupon-carro__codigo';
          li.dataset.codigo = d.code;
          const nombre = document.createElement('span');
          nombre.textContent = d.code;
          const quitar = document.createElement('button');
          quitar.type = 'button';
          quitar.className = 'cupon-carro__quitar unstyled-button';
          quitar.setAttribute('aria-label', 'Quitar el código ' + d.code);
          quitar.textContent = '×';
          li.append(nombre, quitar);
          this.lista.appendChild(li);
        });
      }

      async aplicar() {
        const codigo = this.input.value.trim().toUpperCase();
        if (!codigo) {
          this.avisar('Escribe un código.', 'error');
          this.input.focus();
          return;
        }
        const previos = this.actuales();
        if (previos.some((c) => c.toUpperCase() === codigo)) {
          this.avisar('Ese código ya está aplicado.', 'ok');
          return;
        }
        this.classList.add('cargando');
        this.avisar('');
        try {
          let carro = await this.enviar(previos.concat(codigo));
          const resultado = (carro.discount_codes || []).find((d) => d.code.toUpperCase() === codigo);
          if (!resultado || !resultado.applicable) {
            carro = await this.enviar(previos);
            this.redibujar(carro);
            this.avisar('El código ' + codigo + ' no es válido o no aplica a los productos de tu carro.', 'error');
          } else {
            this.redibujar(carro);
            this.input.value = '';
            this.avisar('Código ' + codigo + ' aplicado.', 'ok');
          }
        } catch (e) {
          this.avisar('No pudimos aplicar el código. Inténtalo de nuevo.', 'error');
        } finally {
          this.classList.remove('cargando');
        }
      }

      async quitar(codigo) {
        this.classList.add('cargando');
        try {
          const carro = await this.enviar(this.actuales().filter((c) => c !== codigo));
          this.redibujar(carro);
          this.avisar('Quitaste el código ' + codigo + '.', '');
        } catch (e) {
          this.avisar('No pudimos quitar el código. Inténtalo de nuevo.', 'error');
        } finally {
          this.classList.remove('cargando');
        }
      }
    }
    customElements.define('cupon-carro', CuponCarro);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["oferta-24h-contenido"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('cuenta-24h')) return;

    // Igual que RELAMPAGO_MAX de assets/regios-precios.js
    var MAX_24H = 26 * 3600 * 1000;
    var ZONA = 'America/Santiago';

    function ofertas24h() {
      var nodo = document.getElementById('regios-dopp-config');
      if (!nodo) return [];
      var datos;
      try { datos = JSON.parse(nodo.textContent); } catch (e) { return []; }
      var configs = (datos && datos.discountConfigs) || {};
      var lista = [];
      Object.keys(configs).forEach(function (id) {
        var crudo = configs[id];
        if (!crudo || crudo === 'null') return;
        var d;
        try { d = typeof crudo === 'string' ? JSON.parse(crudo) : crudo; } catch (e) { return; }
        if (!d || !d.config || d.config.isEnabled === false || !d.startDate || !d.endDate) return;
        var desde = Date.parse(d.startDate), hasta = Date.parse(d.endDate);
        if (isNaN(desde) || isNaN(hasta) || hasta - desde > MAX_24H) return;
        lista.push({ desde: desde, hasta: hasta });
      });
      return lista;
    }

    function fechaLarga(ms) {
      var t = new Intl.DateTimeFormat('es-CL', { timeZone: ZONA, weekday: 'long', day: 'numeric', month: 'long' }).format(ms);
      t = t.replace(',', '');
      return t.charAt(0).toUpperCase() + t.slice(1);
    }
    function hora(ms) {
      return new Intl.DateTimeFormat('es-CL', { timeZone: ZONA, hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).format(ms);
    }
    function dos(n) { return (n < 10 ? '0' : '') + n; }

    class Cuenta24h extends HTMLElement {
      connectedCallback() {
        this.q = function (s) { return this.querySelector('[' + s + ']'); }.bind(this);
        this.elegir();
      }
      disconnectedCallback() { clearInterval(this.reloj); }

      elegir() {
        clearInterval(this.reloj);
        var ahora = Date.now();
        var lista = ofertas24h();
        var vigente = lista.filter(function (o) { return o.desde <= ahora && ahora < o.hasta; })
          .sort(function (a, b) { return a.hasta - b.hasta; })[0];
        var proxima = lista.filter(function (o) { return o.desde > ahora; })
          .sort(function (a, b) { return a.desde - b.desde; })[0];

        if (vigente) {
          this.meta = vigente.hasta;
          this.q('data-etiqueta').textContent = 'Termina en';
          this.q('data-fecha').innerHTML = fechaLarga(vigente.desde) + ' · <span>hasta las ' + hora(vigente.hasta) + '</span>';
        } else if (proxima) {
          this.meta = proxima.desde;
          this.q('data-etiqueta').textContent = 'Comienza en';
          this.q('data-fecha').innerHTML = 'Próxima oferta: ' + fechaLarga(proxima.desde) + ' · <span>desde las ' + hora(proxima.desde) + '</span>';
        } else {
          this.q('data-fecha').hidden = true;
          this.q('data-caja').hidden = true;
          var vacio = this.q('data-vacio');
          vacio.textContent = this.dataset.sinOferta || '';
          vacio.hidden = !vacio.textContent;
          return;
        }
        this.q('data-vacio').hidden = true;
        this.q('data-fecha').hidden = false;
        this.q('data-caja').hidden = false;
        this.pintar();
        this.reloj = setInterval(this.pintar.bind(this), 1000);
      }

      pintar() {
        var resta = this.meta - Date.now();
        if (resta <= 0) { this.elegir(); return; }
        var s = Math.floor(resta / 1000);
        var dias = Math.floor(s / 86400);
        this.q('data-dias-caja').hidden = dias === 0;
        this.q('data-dias').textContent = dias;
        this.q('data-horas').textContent = dos(Math.floor((s % 86400) / 3600));
        this.q('data-minutos').textContent = dos(Math.floor((s % 3600) / 60));
        this.q('data-segundos').textContent = dos(s % 60);
      }
    }
    customElements.define('cuenta-24h', Cuenta24h);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["preventa-whatsapp"] && !Shopify.designMode) return;
  try {
    (function () {
    function iniciar(caja) {
      if (caja.dataset.listo) return;
      caja.dataset.listo = '1';
      var form = document.getElementById(caja.dataset.form);
      if (!form) return;
      var variantes = {};
      (caja.dataset.variantes || '').split('|').forEach(function (par) {
        var i = par.indexOf('=');
        if (i > 0) variantes[par.slice(0, i)] = par.slice(i + 1);
      });
      var boton = caja.querySelector('a');
      var contenedor = form.closest('product-form') || form;

      var cotizar = caja.dataset.modo === 'Cotizar';
      if (cotizar) (form.closest('.product__info-container') || contenedor).classList.add('cotizar-activa');

      function actualizar() {
        var add = form.querySelector('[name="add"]');
        var id = (form.querySelector('[name="id"]') || {}).value;
        var sinStock = !add || add.disabled;
        caja.hidden = !cotizar && !sinStock;
        contenedor.classList.toggle('preventa-activa', !cotizar && sinStock);
        var nombre = caja.dataset.producto + (variantes[id] ? ' (' + variantes[id] + ')' : '');
        var texto = (caja.dataset.accion === 'cotizar' ? 'Hola! Quiero cotizar: ' : 'Hola! Quiero reservar en preventa: ') + nombre + ' ' + caja.dataset.url;
        boton.href = 'https://wa.me/' + caja.dataset.telefono + '?text=' + encodeURIComponent(texto);
      }

      actualizar();
      new MutationObserver(actualizar).observe(form, {
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled', 'value'],
      });
      form.addEventListener('change', function () { setTimeout(actualizar, 50); });
    }
    function todas() {
      document.querySelectorAll('[data-preventa-wa]').forEach(iniciar);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todas);
    else todas();
    document.addEventListener('shopify:section:load', todas);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-fluido"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__videoFluido) return;
    window.__videoFluido = true;

    var sinAnimacion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ahorroDatos = navigator.connection && navigator.connection.saveData;

    function cargar(video) {
      if (video.dataset.cargado) return;
      video.dataset.cargado = '1';
      var pendientes = video.querySelectorAll('source[data-src]');
      // El de la primera vista ya trae src: recargarlo lo reiniciaría
      if (!pendientes.length) return;
      pendientes.forEach(function (s) {
        s.src = s.dataset.src;
        s.removeAttribute('data-src');
      });
      video.load();
    }

    function reproducir(video) {
      if (!video.hasAttribute('data-reproducir') || sinAnimacion || ahorroDatos) return;
      var promesa = video.play();
      if (promesa && promesa.catch) promesa.catch(function () {});
    }

    function iniciar(raiz) {
      var videos = (raiz || document).querySelectorAll('video[data-video-fluido]:not([data-observado])');
      videos.forEach(function (video) {
        video.setAttribute('data-observado', '');
        video.muted = true;

        // Con ahorro de datos o sin animaciones, el video de fondo no se descarga: queda la portada
        if (video.hasAttribute('data-reproducir') && (sinAnimacion || ahorroDatos) && !video.controls) {
          video.removeAttribute('autoplay');
          return;
        }

        // Primera vista: arranca cuando la página terminó de cargar
        if (video.hasAttribute('data-tras-carga')) {
          var arrancar = function () {
            var go = function () { cargar(video); reproducir(video); };
            if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 1500 }); else setTimeout(go, 200);
          };
          if (document.readyState === 'complete') arrancar(); else window.addEventListener('load', arrancar, { once: true });
        }

        if (!('IntersectionObserver' in window)) {
          cargar(video);
          reproducir(video);
          return;
        }

        var observador = new IntersectionObserver(function (entradas) {
          entradas.forEach(function (e) {
            if (e.isIntersecting) {
              if (video.hasAttribute('data-tras-carga') && !video.dataset.cargado) return;
              cargar(video);
              reproducir(video);
            } else if (video.dataset.cargado && !video.paused && video.hasAttribute('data-reproducir')) {
              video.pause();
            }
          });
        }, { rootMargin: '300px 0px' });
        observador.observe(video);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { iniciar(); });
    } else {
      iniciar();
    }
    // Secciones que el editor del theme vuelve a dibujar
    document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });

    // Videos que el theme inserta después desde un <template> (video.liquid, banner-grid)
    if ('MutationObserver' in window) {
      new MutationObserver(function (cambios) {
        for (var i = 0; i < cambios.length; i++) {
          if (cambios[i].addedNodes.length) { iniciar(); return; }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
